module.exports = __webpack_public_path__ + "img/mail.08f50678.svg";